const toEnglishNumber = (inputDate) => {
    let ret = 0;
  
    if (inputDate !== undefined)
      ret = inputDate.toString().replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
  
    return ret;
  };
  export default toEnglishNumber;
  